module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showConnectedResevatios) ? _c('span', {
    staticClass: "light mr-1 font-weight-400"
  }, [_vm._v("Related bookings:")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.linkedBookings), function(linkedBooking) {
    return [(_vm.linkedBookingsContainCurrentBooking(linkedBooking) == false) ? [_c('span', {
      staticClass: "pointer reservationId",
      class: {
        'selected': _vm.currentBooking == linkedBooking
      },
      on: {
        "click": function($event) {
          _vm.clickReservation(_vm.lastArrayItem(linkedBooking))
        }
      }
    }, [_vm._v("\n                " + _vm._s(("#" + (_vm.lastArrayItem(linkedBooking)))) + "\n            ")])] : [_c('span', {
      class: {
        'rebookGroup': linkedBooking.length > 1
      }
    }, _vm._l((linkedBooking), function(internalBooking) {
      return _c('span', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: (internalBooking != _vm.lastArrayItem(linkedBooking) ? 'Rebooked' : null),
          expression: "internalBooking != lastArrayItem(linkedBooking)?'Rebooked':null"
        }],
        staticClass: "pointer reservationId",
        class: {
          'selected': _vm.currentBooking == internalBooking,
          'rebookParent': internalBooking != _vm.lastArrayItem(linkedBooking)
        },
        on: {
          "click": function($event) {
            return _vm.clickReservation(internalBooking)
          }
        }
      }, [_vm._v("\n                    #" + _vm._s(internalBooking) + "\n                ")])
    }), 0)]]
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-d07ed80c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d07ed80c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/ConnectedReservations.vue
// module id = 1889
// module chunks = 0